export const initOptions: Array<InitOptions> = [
  {
    value: 7,
    label: "已签收",
  },
  {
    value: 9,
    label: "已完成",
  },
  {
    value: 11,
    label: "已关闭",
  },
  {
    value: 13,
    label: "无效订单",
  },
];

export interface InitOptions {
  value: number,
  label: string
}